export const EstadoVistaColaborador = Object.freeze({    
    PENDIENTE :"PENDIENTE",
    PENDIENTE_APROBACION :"PENDIENTE_APROBACION",
    VISUALIZADO:"VISUALIZADO", 
    FIRMADO:"FIRMADO",
})